import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_198_15409)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6.19844 6.60039H5.39844M10.5984 6.60039H9.79844M14.5984 8.00039C14.5984 11.6455 11.6435 14.6004 7.99844 14.6004C4.35336 14.6004 1.39844 11.6455 1.39844 8.00039C1.39844 4.35531 4.35336 1.40039 7.99844 1.40039C11.6435 1.40039 14.5984 4.35531 14.5984 8.00039ZM10.1984 10.2004C9.39844 12.6004 6.59844 12.6004 5.79844 10.2004H10.1984Z",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_198_15409",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSmile);
export { ForwardRef as ReactComponent };
